module.exports = __webpack_public_path__ + "img/yj_app_to_see.1e9be997.png";